import { createSvgIcon } from '@mui/material/utils';
import { AllianceAppKey } from './alliance-apps';

/**
 * App glyphs for the App Launcher tiles, the Sign In eyebrow and the System
 * Screens. 24×24 grid, 2px round stroke, currentColor, no fills. DMD reuses
 * the Alliance ARC and Contracting glyphs (DMD App System, "App icons").
 */
const strokeIcon = (paths: string[], displayName: string) =>
  createSvgIcon(
    <g
      fill="none"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    >
      {paths.map((d) => (
        <path key={d} d={d} />
      ))}
    </g>,
    displayName,
  );

/** A speedometer: Dashboard is where agents check how they are performing */
const DashboardIcon = strokeIcon(
  [
    'M3.34 19A10 10 0 1 1 20.66 19',
    'M12 14l4.5-5',
    'M10.5 14a1.5 1.5 0 1 0 3 0a1.5 1.5 0 1 0-3 0',
    'M12 5v1.5',
    'M5.6 7.6l1 1',
    'M18.4 7.6l-1 1',
    'M3 14h1.5',
    'M19.5 14H21',
  ],
  'DashboardIcon',
);

/** A contract page with a folded corner and a signature stroke */
const ContractingIcon = strokeIcon(
  [
    'M14 3H7a1 1 0 0 0-1 1v16a1 1 0 0 0 1 1h10a1 1 0 0 0 1-1V7z',
    'M14 3v4h4',
    'M9 16c1-1.5 1.7 1.5 2.6 0s1.7 1.5 2.4 0',
  ],
  'ContractingIcon',
);

/** Look up an app's glyph by key */
export const APP_ICONS: Record<AllianceAppKey, typeof DashboardIcon> = {
  dashboard: DashboardIcon,
  contracting: ContractingIcon,
};
